import { useEffect, useState } from "react";
import "./App.css";
import HomePage from "./frountpage/HomePage";
function App() {
  const [faviconUrl, setFaviconUrl] = useState("./l22.jpg");

  useEffect(() => {
    const link =
      document.querySelector("link[rel*='icon']") ||
      document.createElement("link");
    link.rel = "icon";
    link.href = faviconUrl;
    document.head.appendChild(link);
  }, [faviconUrl]);
  return <HomePage />;
}

export default App;
